<template>
	<page>
		<module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="队列名称">
                    <c-input name="queues" maxlength="200"></c-input>
                </m-search-item>
                <m-search-item>
                    <c-checkbox-group name="flag" :options="flagType"></c-checkbox-group>
                </m-search-item>
            </m-search>

			<m-operate>
				<c-button power="b_mq_error_log_edit" color="sys" @click="batchEdit()">批量处理</c-button>
			</m-operate>

			<c-table ref="table" code="mq_error_log_list">

				<c-table-column
					type="selector"
				>
				</c-table-column>

				<c-table-column
					label="状态"
					name="flag"
					width="60"
				>
					<template v-slot="{data}">
						
						<span v-if="data.flag == 1" style="color:green">已处理</span>
						<span v-else style="color:red">待处理</span>
					</template>
				</c-table-column>

				<c-table-column
						label="队列名称"
						name="queues"
						width="170"
				>
				</c-table-column>

				<c-table-column
					label="队列消息"
					name="message"
					width="400"
					ellipsis
				>
				</c-table-column>
				
				<c-table-column
					label="错误日志"
					name="error_log"
					width="200"
					ellipsis
				>
				</c-table-column>
				
				<c-table-column
					label="创建日期"
					name="create_date"
					width="140"
				>
				</c-table-column>
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
					<template v-slot="{data}">
<!--						<c-table-button  v-if="data.flag == 0" icon="tf-copy" @click="clipboard(data.message)">复制JSON</c-table-button>-->
<!--						<c-table-button  v-if="data.flag == 0" icon="tf-copy" @click="clipboard(data.error_log)">复制ERROR</c-table-button>-->
						<c-table-button  v-if="data.flag == 0" power="b_mq_error_log_edit" icon="tf-edit" @click="edit(data)">处理</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_mq_error_log',
		
		data() {
			return {
				flagType:[{
					name:'未处理',
					value:0
				},{
					name:'已处理',
					value:1
				}]
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},

		methods: {

			searchHandle(data) {
				this.$refs.table.load({
					url: '/mq_error_log/list',
					data
				});
			},

			edit(val) {
				this.$confirm({
                    message: '确定要处理【'+val.queues+'】MQ错误消息吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/mq_error_log/edit',
							data: {ids:[val.id]},
							loading: true,
							success: data => {
								this.$message({
									message: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			batchEdit() {
				let list = this.$refs.table.getRow('selected');
				if (!list.length) {
					this.$message({
                        message: '请选择要操作的MQ错误日志'
					});
					return;
				}

				for(let i = 0;i<list.length;i++){
					if(list[i].data.flag ==1){
						this.$message({
                            message: '已选择的MQ错误日志包含已处理数据'
						});
						return;
					}
				}
				this.$confirm({
                    message: '确定要处理批量处理MQ错误消息吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/mq_error_log/edit',
							data: {ids:Array.from(list, item => item.data.id)},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
		}
	}
</script>